import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  Col, Row, Form, Button,
} from 'react-bootstrap';
import axios from 'axios';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Content } from '../styles';
import ModalKonfirmasi from '../../../../components/ModalKonfirmasi';
import config from '../../../../config';

const FormBuatKlaim = (props) => {
  const formData = new FormData();
  const url = config.API_BASE_URL;
  const [sertif, setSertif] = useState();
  const [buktiRegis, setbuktiRegis] = useState();
  const [dataDiri, setDataDiri] = useState({
    id: '',
    user: { name: '', username: '', npmnip: '' },
    angkatan: '',
    prodi: '',
  });
  const [modalShow, setModalShow] = useState(false);
  const [infokum, setInfokum] = useState([]);
  const [state, setState] = useState({
    nama: '',
    npm: '',
    angkatan: '',
    prodi: 'S1 Reguler Ilmu Ekonomi',
    email: '',
    no_telepon: '',
    opsi: '',
    file_sertifikat: '',
    ketersediaan: 'true',
    nama_kegiatan: '',
    jenis_kegiatan: 'kuliah umum',
    tanggal: '',
    pukul: '',
    penyelenggara: '',
    biaya: '',
    sertifikat: 'Ya (E-Sertifikat)',
    informasi_lain: '',
    bukti_regis: '',
    lokasi: '',
    pembicara: '',
    moderator: '',
  });
  const [error, setError] = useState({
    sertif: '',
    regis: '',
  });

  const SUPPORTED_FORMATS = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'application/pdf'];
  const FILESIZE = 10485760;

  const handleImageChange = (e) => {
    setSertif({
      file: e.target.files[0],
    });
  };

  const handleBuktiChange = (e) => {
    setbuktiRegis({
      image: e.target.files[0],
    });
  };

  const inputChange = (e, input) => {
    const ubah = e.target.value;
    setState({
      ...state,
      [input]: ubah,
    });
  };

  useEffect(() => {
    axios.get(`${url}api/account/detail-info/`, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }).then((info) => {
      setDataDiri(
        info.data,
      );
    }).catch(() => {
    });

    setInfokum([]);
    axios.get(`${url}api/kuliah_umum/filter/?date=today`, {
      headers: {
        accept: 'application/json',
      },
    }).then((info) => {
      setInfokum(
        info.data,
      );
    }).catch(() => {
    });

    axios.get(`${url}api/kuliah_umum/filter/?date=before`, {
      headers: {
        accept: 'application/json',
      },
    }).then((info) => {
      setInfokum(
        info.data,
      );
    }).catch(() => {
    });
  }, []);

  const formik = useFormik({
    initialValues: {
      nama: '',
      npm: '',
      angkatan: '',
      prodi: '',
      email: '',
      no_telepon: '',
      file_sertifikat: '',
      kum_id: '',
      ketersediaan: 'true',
      nama_kegiatan: '',
      jenis_kegiatan: 'kuliah umum',
      tanggal: '',
      pukul: '',
      penyelenggara: '',
      biaya: '',
      sertifikat: 'Ya (E-Sertifikat)',
      bukti_regis: '',
      informasi_lain: '',
      lokasi: '',
      pembicara: '',
      moderator: '',
    },
    validationSchema: Yup.object({
      no_telepon: Yup.string().required('Nomor Telepon harus diisi!'),
    }),
    onSubmit: () => {
      if (state.ketersediaan === 'true') {
        formData.append('kum_id', state.kum_id);
      }

      if (state.ketersediaan === 'false') {
        formData.append('nama_kegiatan', state.nama_kegiatan);
        formData.append('jenis_kegiatan', state.jenis_kegiatan);
        formData.append('tanggal', state.tanggal);
        formData.append('pukul', state.pukul);
        formData.append('penyelenggara', state.penyelenggara);
        if (state.biaya !== '') {
          formData.append('biaya', parseInt(state.biaya, 10));
        }
        formData.append('sertifikat', state.sertifikat);
        formData.append('lokasi', state.lokasi);
        formData.append('pembicara', state.pembicara);
        if (state.moderator !== '') {
          formData.append('moderator', state.moderator);
        }
      }
      if (state.informasi_lain !== '') {
        formData.append('informasi_lain', state.informasi_lain);
      }
      formData.append('no_telepon', state.no_telepon);
      formData.append('bukti_regis', buktiRegis.image, buktiRegis.image.name);
      if (sertif?.length !== 0) {
        formData.append('file_sertifikat', sertif.file, sertif.file.name);
      }
      axios.post(`${config.API_BASE_URL}api/partisipasi_kuliah_umum/`, formData, {
        headers: {
          'content-type': 'multipart/form-data',
          accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }).then(
        () => (
          props.history.push('/')
        ),
      );
    },
  });

  const handleSubmit1 = () => {
    let errorText = error.regis;
    if (buktiRegis) {
      const value = buktiRegis.image;
      if (!SUPPORTED_FORMATS.includes(value.type)) {
        errorText = 'Bukti harus berupa PDF atau Gambar';
      } else if (value.size > FILESIZE) {
        errorText = 'Maksimum ukuran bukti 10 MB!';
      } else {
        errorText = '';
      }
    } else {
      errorText = 'Bukti registrasi harus ada!';
    }

    let errorText2 = error.sertif;
    if (sertif) {
      const value = sertif.file;
      if (!SUPPORTED_FORMATS.includes(value.type)) {
        errorText2 = 'Sertifikat harus berupa PDF atau Gambar';
      } else if (value.size > FILESIZE) {
        errorText2 = 'Maksimum ukuran sertifikat 10 MB!';
      } else {
        errorText2 = '';
      }
    }

    if (errorText === '' && errorText2 === '') {
      formik.handleSubmit();
    }
    setError({
      sertif: errorText2,
      regis: errorText,
    });
    setModalShow(false);
  };

  return (
    <Content>
      <Form>
        <h1 className="mb-4">Selamat Datang di Pengajuan Partisipasi Kuliah Umum Baru!</h1>
        <h1 className="mb-5">Data Diri</h1>
        <Form.Group as={Row}>
          <Form.Label column sm="2" data-testid="nama">
            <p>Nama</p>
          </Form.Label>
          <Col sm="10">
            <Form.Label>
              <p>{dataDiri.user.name}</p>
            </Form.Label>
          </Col>
        </Form.Group>

        <Form.Group as={Row}>
          <Form.Label column sm="2" data-testid="npm">
            <p>NPM</p>
          </Form.Label>
          <Col sm="10">
            <Form.Label>
              <p>{dataDiri.user.npmnip}</p>
            </Form.Label>
          </Col>
        </Form.Group>

        <Form.Group as={Row}>
          <Form.Label column sm="2">
            <p>Angkatan</p>
          </Form.Label>
          <Col sm="10">
            <Form.Label>
              <p>{dataDiri.angkatan}</p>
            </Form.Label>
          </Col>
        </Form.Group>

        <Form.Group as={Row}>
          <Form.Label column sm="2">
            <p>Program Studi</p>
          </Form.Label>
          <Col sm="10">
            <Form.Label>
              <p>{dataDiri.prodi}</p>
            </Form.Label>
          </Col>
        </Form.Group>

        <Form.Group as={Row}>
          <Form.Label column sm="2">
            <p>Alamat Email</p>
          </Form.Label>
          <Col sm="10">
            <Form.Label>
              <p>
                {dataDiri.user.username}
                @ui.ac.id
              </p>
            </Form.Label>
          </Col>
        </Form.Group>

        <Form.Group as={Row}>
          <Form.Label column sm="2">
            <p>
              Nomor Telepon
              <span style={{ color: 'red' }}>*</span>
            </p>
          </Form.Label>
          <Col sm="10">
            <Form.Control
              type="text"
              placeholder="085697977674"
              name="no_telepon"
              data-testid="no_telepon"
              onChange={(e) => { formik.handleChange(e); inputChange(e, 'no_telepon'); }}
              value={state.no_telepon}
            />
            {formik.errors.no_telepon && formik.touched.no_telepon && (
            <div data-testid="no_telepon_error" className="text-danger">{formik.errors.no_telepon}</div>
            )}
          </Col>
        </Form.Group>

        <h1 className="mb-5">Data Kegiatan</h1>

        <Form.Group as={Row}>
          <Form.Label column sm="8">
            <p>Apakah data kegiatan terdaftar di website layanan KUM?</p>
          </Form.Label>
          <Col sm="4">
            <Form.Control type="text" as="select" data-testid="ketersediaan" name="ketersediaan" onChange={(e) => { formik.handleChange(e); inputChange(e, 'ketersediaan'); }} value={state.ketersediaan}>
              <option value="true">Ya</option>
              <option value="false">Tidak</option>
            </Form.Control>
          </Col>
        </Form.Group>

        {state.ketersediaan === 'false'
          && (
            <Form>
              <Form.Group as={Row}>
                <Form.Label column sm="2">
                  <p>
                    Nama Kegiatan
                    <span style={{ color: 'red' }}>*</span>
                  </p>
                </Form.Label>
                <Col sm="10">
                  <Form.Control
                    type="text"
                    id="form1"
                    placeholder="Kuliah Umum Ekonomi"
                    name="nama_kegiatan"
                    data-testid="nama_kegiatan"
                    onChange={(e) => { formik.handleChange(e); inputChange(e, 'nama_kegiatan'); }}
                    value={state.nama_kegiatan}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column sm="2">
                  <p>
                    Jenis Kegiatan
                    <span style={{ color: 'red' }}>*</span>
                  </p>
                </Form.Label>
                <Col sm="10">
                  <Form.Control type="text" as="select" data-testid="jenis_kegiatan" name="jenis_kegiatan" className="jenis_kegiatan" onChange={(e) => { formik.handleChange(e); inputChange(e, 'jenis_kegiatan'); }} value={state.jenis_kegiatan}>
                    <option value="kuliah umum">kuliah umum</option>
                    <option value="seminar ilmiah">seminar ilmiah</option>
                  </Form.Control>
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column sm="2">
                  <p>
                    Hari/Tanggal
                    <span style={{ color: 'red' }}>*</span>
                  </p>
                </Form.Label>
                <Col sm="10">
                  <Form.Control type="date" className="tanggal" name="tanggal" data-testid="tanggal" onChange={(e) => { formik.handleChange(e); inputChange(e, 'tanggal'); }} value={state.tanggal} />
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column sm="2">
                  <p>
                    Pukul
                    <span style={{ color: 'red' }}>*</span>
                  </p>
                </Form.Label>
                <Col sm="10">
                  <Form.Control type="time" data-testid="pukul" className="pukul" name="pukul" onChange={(e) => { formik.handleChange(e); inputChange(e, 'pukul'); }} value={state.pukul} />
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column sm="2">
                  <p>
                    Penyelenggara
                    <span style={{ color: 'red' }}>*</span>
                  </p>
                </Form.Label>
                <Col sm="10">
                  <Form.Control type="text" className="penyelenggara" name="penyelenggara" data-testid="penyelenggara" placeholder="BEM FEB UI" onChange={(e) => { formik.handleChange(e); inputChange(e, 'penyelenggara'); }} value={state.penyelenggara} />
                </Col>

              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column sm="2">
                  <p>Biaya (Dalam Rupiah)</p>
                </Form.Label>
                <Col sm="10">
                  <Form.Control min="0" type="number" data-testid="biaya" className="biaya" name="biaya" onChange={(e) => { formik.handleChange(e); inputChange(e, 'biaya'); }} value={state.biaya} />
                </Col>

              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column sm="2">
                  <p>
                    Sertifikat
                    <span style={{ color: 'red' }}>*</span>
                  </p>
                </Form.Label>
                <Col sm="10">
                  <Form.Control type="text" as="select" data-testid="sertifikat" className="sertifikat" name="sertifikat" placeholder="Ya (Sertifikat Elektronik)" onChange={(e) => { formik.handleChange(e); inputChange(e, 'sertifikat'); }} value={state.sertifikat}>
                    <option value="Ya (Tersedia)">Ya (Tersedia)</option>
                    <option value="Ya (Berbayar)">Ya (Berbayar)</option>
                    <option value="Tidak Tersedia">Tidak Tersedia</option>
                  </Form.Control>
                </Col>

              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column sm="2">
                  <p>
                    Lokasi
                    <span style={{ color: 'red' }}>*</span>
                  </p>
                </Form.Label>
                <Col sm="10">
                  <Form.Control type="text" data-testid="lokasi" className="lokasi" name="lokasi" placeholder="Balairung UI" onChange={(e) => { formik.handleChange(e); inputChange(e, 'lokasi'); }} value={state.lokasi} />
                </Col>

              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column sm="2">
                  <p>
                    Pembicara
                    <span style={{ color: 'red' }}>*</span>
                  </p>
                </Form.Label>
                <Col sm="10">
                  <Form.Control type="text" data-testid="pembicara" className="pembicara" name="pembicara" placeholder="Fathurizki Luthfi Azzahra" onChange={(e) => { formik.handleChange(e); inputChange(e, 'pembicara'); }} value={state.pembicara} />
                </Col>

              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column sm="2">
                  <p>Moderator</p>
                </Form.Label>
                <Col sm="10">
                  <Form.Control type="text" data-testid="moderator" className="moderator" name="moderator" placeholder="Talitha Luthfi" onChange={(e) => { formik.handleChange(e); inputChange(e, 'moderator'); }} value={state.moderator} />
                </Col>

              </Form.Group>

            </Form>

          )}

        {state.ketersediaan === 'true'
          && (
            <Form>

              <Form.Group as={Row} controlId="formPlaintextJenisKegiatan">
                <Form.Label column sm="2">
                  <p>
                    Nama Kegiatan
                    <span style={{ color: 'red' }}>*</span>
                  </p>
                </Form.Label>
                <Col sm="10">
                  <Form.Control type="text" as="select" data-testid="kum_id" name="kum_id" className="kum_id" onChange={(e) => { formik.handleChange(e); inputChange(e, 'kum_id'); }} value={state.kum_id}>
                    {infokum.map((post) => (
                      <option key={post.id} value={post.id}>{post.nama_kegiatan}</option>
                    ))}
                  </Form.Control>
                </Col>
              </Form.Group>

            </Form>
          )}

        <Form.Group as={Row}>
          <Form.Label column sm="2">
            <p>Informasi Lain</p>
          </Form.Label>
          <Col sm="10">
            <Form.Control type="text" data-testid="informasi_lain" className="informasi_lain" name="informasi_lain" placeholder="Kegiatan seminar adalah rekomendasi dosen." onChange={(e) => { formik.handleChange(e); inputChange(e, 'informasi_lain'); }} value={state.informasi_lain} />
          </Col>

        </Form.Group>
        <h1 className="mb-5">Tambahkan Berkas</h1>

        <Form.Group as={Row}>
          <Form.Label column sm="2">
            <p>
              Upload Bukti Registrasi
              <span style={{ color: 'red' }}>*</span>
            </p>
          </Form.Label>
          <Col sm="10">
            <Form.Control
              type="file"
              className="sertifikat-uploader"
              data-testid="regis"
              accept="image/png, image/jpeg, application/pdf"
              onChange={(e) => handleBuktiChange(e)}
            />
          </Col>
        </Form.Group>
        {error.regis !== '' && (
          <div data-testid="bukti_error" className="text-danger">{error.regis}</div>
        )}

        <Form.Group as={Row}>
          <Form.Label column sm="2">
            <p>
              Upload Sertifikat
            </p>
          </Form.Label>
          <Col sm="10">
            <Form.Control
              type="file"
              className="sertifikat-uploader"
              data-testid="foto_sertifikat"
              accept="application/pdf, image/png, image/jpeg"
              onChange={(e) => handleImageChange(e)}
            />
          </Col>
        </Form.Group>
        {error.sertif !== '' && (
          <div data-testid="sertif_error" className="text-danger">{error.sertif}</div>
        )}

        <Col className="col-12 text-right buttonKanan">
          <Link to="/">
            <Button className="btnCancel btn-primary mr-2" variant="danger">Batal</Button>
          </Link>
          <Button className="btnKirim btn-primary" variant="success" onClick={() => setModalShow(true)}>Kirim</Button>
        </Col>
        <ModalKonfirmasi
          show={modalShow}
          onHide={() => setModalShow(false)}
          onSubmit={handleSubmit1}
        />
      </Form>
    </Content>
  );
};

FormBuatKlaim.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(FormBuatKlaim);
